<template>
  <div id="Review">
    <div style="padding: 0 0.5rem 0.5rem">
      <b-button variant="primary"  @click="save()"
        ><b-icon icon="check" />&nbsp;{{ $t("message.Save_cmd") }}</b-button
      >&nbsp;&nbsp;
      <b-button  @click="hideModal()"
        ><b-icon icon="x" />&nbsp;{{ $t("message.Close_cmd") }}</b-button
      >
    </div>
    <div
      class="well"
      style="   margin-bottom: 0;        position: relative;
        overflow: auto;
                max-height: 29rem;

        width: 100%;        border-bottom: 1px solid #111;
        border-top: 1px solid #111;
      "
    >
      <table
        style="border: 2.5px solid; padding: 5px; width: 100%"
        rules="all"
        cellpadding="5"
        v-if="_props != null"
      >
        <tbody style="line-height: 1.5rem">
          <tr style="height: 3.5em">
            <td class="ncut-edit-form-text label-td" style="width: 7.5rem">
              申請案件編號：
            </td>
            <td class="ncut-base-form-ipt text-td" style="min-width: 7rem">
              {{ _props.id }}
            </td>
            <td class="ncut-edit-form-text label-td" style="width: 7rem">
              學號:
            </td>
            <td class="ncut-base-form-ipt text-td" style="min-width: 10rem">
              {{ _props.sid }}
            </td>
          </tr>
          <tr style="height: 3.5em">
            <td class="ncut-edit-form-text label-td" style="min-width: 7rem">
              審核結果:
            </td>
            <td class="ncut-edit-form-text label-td" style="width: 7.5rem">
              <b-form-select
                class="form-control"
                id="IsCompleteSelectText"
                v-model="selected2"
                ref="selected2"
                @change="UpdateIsComplete()"
                :options="options2"
              >
              </b-form-select>
            </td>

            <td v-if="queryInfo.IsComplete ==3" class="ncut-edit-form-text label-td" style="width: 7rem">
              原因：
              <input type="text" maxlength="120" v-model="queryInfo.Reason" />

            </td>
            <td v-else>&nbsp;</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from "@/tool";

export default {
  name: "Review",
  props: ["id", "sid","isComplete"],
  data() {
    return {
      name: null,
      isIE: false,
      inputData: null,
      memo: "無",
      queryInfo: {
        ID: this._props.id,
        Sid: this._props.sid,
        UpdateUser: null,
        IsComplete: null,
        Money: 0,
        Reason: null,
      },
      selected2: this._props.isComplete,
      options2: [
        { value: null, text: "請選擇" },
        { value: "0", text: "待審核" },
        { value: "1", text: "已核准" },
        { value: "2", text: "通過財政調查" },
        { value: "3", text: "退回" },
        { value: "4", text: "退學" },
        { value: "5", text: "準備撥款" },
      ],
    };
  },
  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    UpdateIsComplete() {

      this.queryInfo.IsComplete = this.selected2;


    },
    hideModal() {
      this.$emit("hideModal");
    },
    close() {
      this.$emit("hideModal");
    },
    checkSaveData() {
      let msg = "";

      if (tools.isNullOrEmpty(this.queryInfo.IsComplete)) {
        msg = "審核結果";
      } else if (this.selected2 == 3 && tools.isNullOrEmpty(this.queryInfo.Reason)) {

        msg = "原因";
      }
      return msg;
    },
    save() {




      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;

        this.queryInfo.UpdateUser= this.user.id;
        this.$http
          .put("./WebApi/EconomicDisadvantage/ReviewApply/", this.queryInfo)
          .then((response) => {
            if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,審核成功");
            vm.close();

          } else {
            tools.showAlert(vm, "danger", "對不起,審核失敗");
          }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(
          this,
          "danger",
          "對不起,請輸入".concat(msg).concat("!")
        );
      }
    },


  },
  created() {
    console.log("======created EditReview =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    // this.queryInfo.UpdateUser=this.$store.getters.getUser.id;
    //this.name=this.$store.getters.getUser.name;
    // console.log(this._props.id);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
